import React from "react";
import PropTypes from "prop-types";
import {
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
} from "reactstrap";

import "flatpickr/dist/themes/material_blue.css";
import { AvField, AvForm } from "availity-reactstrap-validation";
import CustomSelect from "../../../../../components/Common/CustomSelect";

const GroupModal = ({
  isOpen,
  toggle,
  editData,
  addGroup,
  updateGroup,
  permissions,
}) => {
  const onSubmit = (e, errors, params) => {
    if (errors?.length === 0) {
      let data = {
        ...params,
      };
      if (editData !== null) {
        updateGroup(editData.id, data);
        toggle();
      } else {
        addGroup(data);
        toggle();
      }
    }
  };

  return (
    <Modal isOpen={isOpen} autoFocus={true} centered={true} toggle={toggle}>
      <div className="modal-header">
        <h4 className="modal-title mt-0" id="myModalLabel">
          {editData !== null ? "Edit" : "Add"} group
        </h4>
        <button
          type="button"
          onClick={toggle}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <AvForm className="needs-validation" onSubmit={onSubmit}>
        <ModalBody>
          <Row>
            <Col className="col-12">
              <div className="mb-3">
                <Label>Group name:</Label>
                <AvField
                  name="name"
                  type="text"
                  errorMessage="This value is required."
                  placeholder="Group name..."
                  value={editData?.name || ""}
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "This value is required",
                    },
                  }}
                />
              </div>
            </Col>
            <Col className="col-12">
              <div className="mb-3">
                <Label>Planned sum:</Label>
                <AvField
                  name="planned_sum"
                  type="number"
                  errorMessage="This value is required."
                  placeholder="Group name..."
                  value={editData?.planned_sum || ""}
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "This value is required",
                    },
                  }}
                />
              </div>
            </Col>
            <Col className="col-12">
              <div className="mb-3">
                <Label>Corrected plan:</Label>
                <AvField
                  name="corrected_plan"
                  type="number"
                  errorMessage="This value is required."
                  placeholder="Corrected plan..."
                  value={editData?.corrected_planned_sum || ""}
                  validate={{
                    required: {
                      value: true,
                      errorMessage: "This value is required",
                    },
                  }}
                />
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="pe-0">
          <Row>
            <Col>
              <div className="text-end">
                <button
                  onClick={e => {
                    e.preventDefault();
                    toggle();
                  }}
                  className="btn btn-primary save-user"
                >
                  Close
                </button>
                {permissions?.["change_managerplanmodel"] && (
                  <button
                    type="submit"
                    className="btn btn-success save-user ms-2"
                  >
                    Save changes
                  </button>
                )}
              </div>
            </Col>
          </Row>
        </ModalFooter>
      </AvForm>
    </Modal>
  );
};

GroupModal.propTypes = {
  editData: PropTypes.any,
  toggle: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  permissions: PropTypes.object.isRequired,
  addGroup: PropTypes.func.isRequired,
  updateGroup: PropTypes.func.isRequired,
};

export default GroupModal;
